import _ from 'lodash';
import { toUnit } from './money';

export const formatPLN = (num?: number | null) => {
  if (_.isNumber(num)) return `${toUnit(num).toFixed(2).replace(/\./g, ',')} zł`;
  return '';
};
